import { render, staticRenderFns } from "./create.vue?vue&type=template&id=64fe24e2&"
import script from "../jscript/create.js?vue&type=script&lang=js&"
export * from "../jscript/create.js?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=64fe24e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports